import { NumericFormat } from "react-number-format";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Yearly } from "../../calculator/calculator";
import { Information } from "../information/InformationInput";

export type StockEvaluationProps = {
  information: Information;
  yearly: Yearly[];
};

export function StockEvaluation(props: StockEvaluationProps) {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center">Year</TableCell>
            <TableCell align="right">Interest</TableCell>
            <TableCell align="right">Saving</TableCell>
            <TableCell align="right">Total Invest</TableCell>
            <TableCell align="right">Portfolio</TableCell>
            <TableCell align="right">Portfolio AT</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.yearly.map((entry) => (
            <TableRow hover={true}>
              <TableCell align="center">{entry.year}</TableCell>
              <TableCell align="right">
                <NumericFormat
                  displayType="text"
                  decimalScale={0}
                  value={entry.stockInterest}
                  thousandSeparator="."
                  decimalSeparator=","
                  suffix=" €"
                />
              </TableCell>
              <TableCell align="right">
                <NumericFormat
                  displayType="text"
                  decimalScale={0}
                  value={entry.stockSaving}
                  thousandSeparator="."
                  decimalSeparator=","
                  suffix=" €"
                />
              </TableCell>
              <TableCell align="right">
                <NumericFormat
                  displayType="text"
                  decimalScale={0}
                  value={entry.stockTotalInvest}
                  thousandSeparator="."
                  decimalSeparator=","
                  suffix=" €"
                />
              </TableCell>
              <TableCell align="right">
                <NumericFormat
                  displayType="text"
                  decimalScale={0}
                  value={entry.stockPortfolio}
                  thousandSeparator="."
                  decimalSeparator=","
                  suffix=" €"
                />
              </TableCell>
              <TableCell align="right">
                <NumericFormat
                  displayType="text"
                  decimalScale={0}
                  value={entry.stockPortfolioAfterTaxes}
                  thousandSeparator="."
                  decimalSeparator=","
                  suffix=" €"
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
